import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, } from 'rxjs/operators';

import { InvitesService } from '../../services/invites.service';
import * as MgmActions from '../actions/mgm.actions';

@Injectable()
export class MgmEffects {

  retrieveConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MgmActions.retrieve),
      switchMap(({id}) =>
        this.invitesService.getMGMConfig(id).pipe(
          map((config) => {
            return MgmActions.retrieveSuccess({ config });
          }),
          catchError((error) =>
            of(MgmActions.retrieveFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private invitesService: InvitesService
  ) {}
}
